module.exports = __webpack_public_path__ + "media/entities/1122-2499c158.png";